// 物件検索処理
import BukkenRepository from '@/repositories/bukkenRepository'
import TagList from '@/constants/tag'
import { MBType } from '@/util/m_b_type.js'
import BuildingEquipments from '@/constants/building_equipments'
import RoomEquipments from '@/constants/room_equipments'
export default {
  data() {
    return {
      TagList: TagList,
      BuildingEquipments: BuildingEquipments,
      RoomEquipments: RoomEquipments,
      range: {},
    }
  },
  computed: {
    master() {
      return this.$store.getters['Master/getMaster']
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    tag: {
      get() {
        return this.$store.getters['Tag/getTag']
      },
      set(val) {
        this.$store.commit('Tag/setTag', val)
      },
    },
    user() {
      return this.$store.getters['User/getUser']
    },
  },
  methods: {
    // 検索項目のリセット
    _searchReset() {
      this.$store.dispatch('SearchProperty/reset')
      this.$store.dispatch('Tag/reset')
      this.$store.dispatch('ConvertSummary/resetSelectSummary')
      this.$store.commit('ConvertSummary/setSelectSummaryText', {})
    },
    // 物件検索処理
    async searchProperty(type, page = 1) {
      this.$store.dispatch('Loading/setLoading', true)

      let params = this.getParams()
      if (params === false) {
        this.$store.dispatch('Loading/setLoading', false)
        return false
      }

      // ページを指定に設定
      params.page = page

      await BukkenRepository.get(params, type)
        .then(resp => {
          // コンバート表示設定の更新
          //   this.convertDisplay = resp.data.meta.user.has_portal_site
          let data = []
          let roomData = resp.body.data.data
          roomData.forEach(room => {
            room.load_convert = 0
            room.convert = []
            data.push(room)
          })

          this.setTag(resp.meta.valid_params)

          const status = {
            total: resp.body.data.total,
            per_page: resp.body.data.per_page,
            current_page: resp.body.data.current_page,
            from: resp.body.data.from,
            to: resp.body.data.to,
          }

          this.$store.commit('Property/setProperty', data)
          this.$store.commit('SearchProperty/setStatus', status)
          this.$store.dispatch('SelectProperty/reset')

          //   setTimeout(this.setTableScroll, 300)
        })
        .catch(e => {
          console.log(e)
          alert('物件データの取得に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })

      await this.$nextTick()
      if (document.querySelector('.table-property')) {
        this.$store.commit('Column/setTableWidth', document.querySelector('.table-property').clientWidth)
      }
    },

    // 検索パラメータを取得する
    getParams() {
      this.customizeParams()
      let params = this.deleteUnnecessaryParam(this.search)
      return params
    },
    // パラメーターのカスタム処理
    customizeParams() {
      // 沿線コード + 沿線名の分離
      for (let i = 1; i <= 3; i++) {
        const lineCdName = this.search[`line_${i}_cd_name`]
        if (lineCdName) {
          const match = lineCdName.match(/^(\d{1}-\d{3})_(.+)$/)
          if (match) {
            this.search[`line_${i}`] = match[1]
            this.search[`line_${i}_name`] = match[2]
          }
        }
      }
    },
    // オブジェクト内の不要なプロパティを削除する
    deleteUnnecessaryParam(object) {
      const _obj = _.cloneDeep(object)
      const condition = val => val === '' || val === null || val === undefined || val === 0

      const _cond = typeof condition === 'function' ? condition : function() {}

      function _remove(obj) {
        for (let o in obj) {
          if (_cond(obj[o])) {
            delete obj[o]
          } else if (typeof obj[o] === 'object' && obj[o].length === 0) {
            delete obj[o]
          }
        }
      }

      _remove(_obj, _cond)
      return _obj
    },
    // 検索タグの生成
    setTag(validParams) {
      delete validParams.page
      delete validParams.per_page
      delete validParams.sort
      validParams = this.deleteUnnecessaryParam(validParams)

      const tag = []
      const TagList = this.TagList

      // 詳細検索系 タグ作成
      const self = this
      _.forEach(validParams, function(value, key) {
        const param = _.find(TagList, {
          value: key,
        })
        if (param) {
          let _tag = self.formatTag(param, value, validParams)
          if (_tag.tag !== '') tag.push(_tag)
        }
      })

      // 地域 検索
      if (validParams.address_arr && validParams.address_arr.length > 0) {
        _.forEach(validParams.address_arr, function(value) {
          const _tag = {
            tag: `地域：${value.str}`,
            type: 'area',
            value: value.cd,
          }
          tag.push(_tag)
        })
      }

      // 駅 検索
      if (validParams.railway_arr && validParams.railway_arr.length > 0) {
        _.forEach(validParams.railway_arr, function(value) {
          // @caution tagの、「沿線・駅：」は、タグ削除時の判定要素として使用中の為、変更時注意！
          // @see src/components/templates/StickySearchTagList.vue
          const _tag = {
            tag: `沿線・駅：${value.str}`,
            type: 'railway',
            value: value.cd,
          }
          tag.push(_tag)
        })
      }

      // 建物詳細 チェックボックス
      _.forEach(this.BuildingEquipments, function(item) {
        _.forEach(item.checkbox, function(checkbox) {
          if (validParams[checkbox.value]) {
            const _tag = {
              value: checkbox.value,
              tag: checkbox.label,
              type: 'flg',
            }
            tag.push(_tag)
          }
        })
      })

      // 部屋詳細 チェックボックス
      _.forEach(this.RoomEquipments, function(item) {
        _.forEach(item.checkbox, function(checkbox) {
          if (validParams[checkbox.value]) {
            const _tag = {
              value: checkbox.value,
              tag: checkbox.label,
              type: 'flg',
            }
            tag.push(_tag)
          }
        })
      })

      // 掲載サマリー
      if (validParams.summary && validParams.summary.length > 0) {
        _.forEach(validParams.summary, function(value) {
          const _tag = {
            tag: `${value.text}`,
            type: 'summary',
          }
          delete value.text
          _tag.value = value
          _tag.summary_value = `${value.shop_id}_${value.cd}_${value.type}`
          tag.push(_tag)
        })
      }

      this.range = {}
      this.tag = tag
    },
    // タグをフォーマット
    formatTag(tag, value, validParams) {
      const _tag = _.cloneDeep(tag)
      if (_tag.type === 'text') {
        _tag.tag += `：${value}`
        if (_tag.unit) _tag.tag += _tag.unit
      }
      // if (tag.type === 'flg') {
      //   tag.tag = `${tag.tag}：${value}`
      // }

      if (tag.type === 'select') {
        _tag.tag += `：${validParams[`${_tag.str}`]}`
      }

      if (_tag.type === 'range') {
        // 範囲系
        if (!this.range[`${_tag._value}`]) {
          let tagText = ''
          const from = validParams[`${_tag._value}_from`]
          const to = validParams[`${_tag._value}_to`]
          if (from && to) {
            tagText = `${from}${_tag.unit} 〜 ${to}${_tag.unit}`
          } else if (from) {
            tagText = `${from}${_tag.unit} 〜`
          } else if (to) {
            tagText = `〜 ${to}${_tag.unit}`
          }
          _tag.tag += `：${tagText}`
          this.range[`${_tag._value}`] = true
        } else {
          _tag.tag = ''
        }
      }

      // 沿線・駅
      if (_tag.type === 'line') {
        let tagText = `${validParams[`line_${_tag._value}_str`]}`
        let fromText = ''
        let ToText = ''
        if (validParams[`station_${_tag._value}_str`]) fromText = validParams[`station_${_tag._value}_str`]
        if (validParams[`station_end_${_tag._value}_str`]) ToText = validParams[`station_end_${_tag._value}_str`]
        tagText += ` ${fromText} 〜 ${ToText}`
        _tag.tag += tagText
      }

      // 担当店舗
      if (_tag.type === 'shop') {
        let tagAry = []
        _.forEach(validParams[`${_tag.str}`], function(value) {
          tagAry.push(value.str)
        })
        _tag.tag += `：${tagAry.join()}`
      }

      // フリータグ
      if (_tag.type === 'freetag_search_word') {
        let tagText = this.formatFreetagType(validParams[_tag.value], validParams[`freetag_search_type_${_tag._value}`])
        _tag.tag += `：${tagText}`
      }

      // 築年数
      if (_tag.type === 'build') {
        if (!this.range[`${_tag._value}`]) {
          let tagText = ''
          if (validParams[`${_tag._value}_y_from`]) tagText += `${validParams[`${_tag._value}_y_from`]}年`
          if (validParams[`${_tag._value}_m_from`]) tagText += `${validParams[`${_tag._value}_m_from`]}ヶ月`
          tagText += ' 〜 '
          if (validParams[`${_tag._value}_y_to`]) tagText += `${validParams[`${_tag._value}_y_to`]}年`
          if (validParams[`${_tag._value}_m_to`]) tagText += `${validParams[`${_tag._value}_m_to`]}ヶ月`
          _tag.tag += `：${tagText}`
          this.range[`${_tag._value}`] = true
        } else {
          _tag.tag = ''
        }
      }

      // 間取り
      if (_tag.type === 'house_plan') {
        if (!this.range[`${_tag.type}`]) {
          let tagText = ''
          if (validParams[`${_tag._value}_from`]) tagText += `${validParams[`${_tag._value}_from`]}`
          tagText += ' 〜 '
          if (validParams[`${_tag._value}_to`]) tagText += `${validParams[`${_tag._value}_to`]}`

          if (validParams.mi_floor_plan_cd && validParams.mi_floor_plan_cd.length > 0) {
            let tagAry = []
            const FloorPlan = this.master.floor_plan
            _.forEach(validParams.mi_floor_plan_cd, function(item) {
              if (item == 99) {
                tagAry.push('その他')
              } else {
                const obj = _.find(FloorPlan, function(o) {
                  return o.cd === item
                })
                tagAry.push(obj.label)
              }
            })
            if (tagAry.length !== 0) tagText += ' ' + tagAry.join()
          }
          _tag.tag += `：${tagText}`
          this.range[`${_tag.type}`] = true
        } else {
          _tag.tag = ''
        }
      }

      if (_tag.type === 'checkboxGroup') {
        let tagAry = []
        if (_tag.value === 'm_b_type') {
          if (validParams.m_b_type && validParams.m_b_type.length > 0) {
            const vaildMBType = validParams.m_b_type
            const mBTypeAry = _.filter(MBType, function(item) {
              return _.includes(vaildMBType, item.value)
            })
            tagAry = _.map(mBTypeAry, item => {
              return item.label
            })
          }
        } else if (_tag.value === 'list_star') {
          const vaildListStar = validParams.list_star
          const listStar = this.user.list_star
          _.forEach(vaildListStar, function(value) {
            const obj = _.find(listStar, function(o) {
              return o.value === value
            })
            tagAry.push(obj.label)
          })
        } else {
          const vaildParam = validParams[_tag.value]
          const self = this
          _.forEach(vaildParam, function(value) {
            const obj = _.find(self.master[_tag.value], function(o) {
              return o.cd === value
            })
            tagAry.push(obj.label)
          })
        }

        _tag.tag += `：${tagAry.join()}`
      }

      return _tag
    },
    formatFreetagType(tagValue, freetagType) {
      switch (freetagType) {
        case 1:
          tagValue += ' - 完全一致'
          break
        case 2:
          tagValue += ' - 前方一致'
          break
        case 3:
          tagValue += ' - 含まない'
          break
        case 4:
          tagValue += ' - 空'
          break
      }
      return tagValue
    },
  },
}
